import React from 'react';

import EventConfigurationContainer from '@totem/components/services/threats/configuration/EventConfigurationContainer';
import EventConfigurationLayout, {
  EventConfigurationExtra,
} from '@totem/components/services/threats/configuration/EventConfigurationLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const EventConfigurationPage = () => (
  <ContentLayout>
    <EventConfigurationContainer>
      <IBCard
        isCovered
        title="Event Configuration"
        extra={<EventConfigurationExtra />}
      >
        <EventConfigurationLayout />
      </IBCard>
    </EventConfigurationContainer>
  </ContentLayout>
);

export default EventConfigurationPage;
